import { styled } from 'styled-system/jsx'

const MeterRoot = styled('div', {
  base: {
    display: 'inline-flex',
    flexDirection: 'column',
    gap: '4px',
  },
  variants: {
    size: {
      sm: { gap: '3px' },
      md: { gap: '5px' },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

const TrackRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
})

const Track = styled('div', {
  base: {
    position: 'relative',
    backgroundColor: '#F0EDFA',
    borderRadius: 'pill',
    overflow: 'hidden',
  },
  variants: {
    size: {
      sm: { width: '64px', height: '6px' },
      md: { width: '120px', height: '8px' },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

const Fill = styled('span', {
  base: {
    display: 'block',
    height: '100%',
    borderRadius: 'pill',
    transition: 'width {durations.standard} {easings.appleStandard}',
  },
  variants: {
    band: {
      comfortable: { backgroundColor: 'quickpass.success' },
      tight: { backgroundColor: 'quickpass.celebration' },
      stretch: { backgroundColor: 'quickpass.warmth' },
      overspend: { backgroundColor: '#D14545' },
    },
  },
  defaultVariants: {
    band: 'comfortable',
  },
})

const PercentLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontWeight: '700',
    color: 'quickpass.ink',
    letterSpacing: '-0.1px',
  },
  variants: {
    size: {
      sm: { fontSize: '11px' },
      md: { fontSize: '13px' },
    },
    band: {
      comfortable: { color: 'quickpass.success' },
      tight: { color: '#A87900' },
      stretch: { color: 'quickpass.warmth' },
      overspend: { color: '#D14545' },
    },
  },
  defaultVariants: {
    size: 'md',
    band: 'comfortable',
  },
})

const BandLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
  },
})

const NoIncomeNote = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontStyle: 'italic',
    color: 'quickpass.inkSoft',
  },
})

export {
  MeterRoot,
  TrackRow,
  Track,
  Fill,
  PercentLabel,
  BandLabel,
  NoIncomeNote,
}
